import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { AppIcon } from "../assets/icons/AppIcon";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./common/CustomTooltip";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const menu = [
    { name: "Solutions", dropdown: true },
    { name: "Features" },
    { name: "Pricing" },
    { name: "Blog", dropdown: true },
    { name: "Restaurants" },
    { name: "Food", dropdown: true },
  ];

  return (
    <nav className="w-full flex items-center justify-between px-4 sm:px-6 md:px-3 py-2 relative">
      {/* LOGO */}
      <div className="flex items-center">
        <AppIcon />
      </div>

      {/* DESKTOP MENU */}
      <div className="hidden md:flex items-center gap-6 lg:gap-10 text-[14px] text-slate-800">
        {menu.map((item, i) => {
          // if(item?.dropdown===true){
          //   return (
          //       <Tooltip followCursor placement="bottom">
          //         <TooltipTrigger>
          //           <button className="px-4 py-2 bg-black text-white rounded">
          //             Hover me
          //           </button>
          //         </TooltipTrigger>

          //         <TooltipContent
          //           className="
          //           w-64 p-4 rounded-xl
          //           bg-white/10 backdrop-blur-xl
          //           border border-white/20
          //           shadow-2xl text-white
          //         "
          //           arrowClass="bg-white/10"
          //         >
          //           <div className="space-y-2">
          //             <h4 className="font-bold text-lg">Profile</h4>
          //             <p className="text-sm opacity-80">
          //               This is fully custom JSX content.
          //             </p>

          //             <button className="mt-2 px-3 py-1 bg-blue-500 rounded">
          //               Action
          //             </button>
          //           </div>
          //         </TooltipContent>
          //       </Tooltip>
          //   );
          // }else{
          return (
            <div
              key={i}
              className="flex items-center gap-1 cursor-pointer hover:text-[#2F3E1F] transition"
            >
              {item.name}
              {item.dropdown && <ChevronDown size={16} className="mt-[2px]" />}
            </div>
          );
          // }
        })}
      </div>

      {/* RIGHT SIDE */}
      <div className="flex items-center gap-3 sm:gap-5">
        {/* SIGN IN */}
        <a className="hidden sm:block text-sm text-[#2F3E1F]/80 hover:text-[#2F3E1F]">
          Sign in
        </a>

        {/* ✅ CTA (ONLY DESKTOP/TABLET) */}
        <button
          className="
          hidden md:block
          bg-[#1F2D16]
          text-white
          px-5 py-2.5
          rounded-full
          shadow-md
          hover:scale-105
          transition
        "
        >
          Get Olive →
        </button>

        {/* MOBILE MENU BUTTON */}
        <button className="md:hidden text-2xl" onClick={() => setOpen(!open)}>
          ☰
        </button>
      </div>

      {/* ✅ MOBILE DROPDOWN */}
      {open && (
        <div
          className="
          absolute top-full left-0 w-full
          bg-white shadow-md
          px-6 py-6
          flex flex-col gap-5
          md:hidden z-50
        "
        >
          {menu.map((item, i) => (
            <div
              key={i}
              className="flex items-center justify-between text-[15px]"
            >
              {item.name}
              {item.dropdown && <ChevronDown size={16} />}
            </div>
          ))}

          {/* ✅ CTA ONLY IN MOBILE MENU */}
          <button className="bg-[#253612] text-white py-2.5 rounded-full mt-2">
            Get Olive →
          </button>
        </div>
      )}
    </nav>
  );
}